import React, { useCallback, useState, useRef, useEffect } from 'react';
import { useHistory, Link } from "react-router-dom";
import { connect } from "react-redux";
import { Button } from 'devextreme-react/button';
import AccordionReact from 'devextreme-react/accordion';
import FormField from '../../../../dynamicFormBuilder/FormField';
import { GridLayout } from "../../../../common/GridLayout";
import { Localization } from "../../../../common/Localization";
import { FillFilters, FormatPhoneNumber, loadLookupFromDataSource } from '../../../../common/Utils'
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import data from "../../../../assets/apiRoutes.json";
import Toolbar, { Item } from "devextreme-react/toolbar";
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar as GridToolbar,
    Item as GridToolbarItem,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
} from "devextreme-react/data-grid";
import { SearchLayout } from './Layout';
import GridLayoutManager from "../../../../gridLayoutCustomization/GridLayoutManager";
import '../../../../common/css/searchPage.css';

const searchpanel = [
    {
        ID: 1,
        Title: 'Search Filters'
    }
];

const List = (props) => {
    const history = useHistory();
    var accessToken = props.oidc.user.access_token;
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const formRefs = useRef({});
    const [selectedItems, setSelectedItems] = useState([]);
    const [searchPanelStatus, setSearchPanelStatus] = useState(false);
    const [isEditButtonDisabled, setIsEditButtonDisabled] = useState(true);
    const rowId = useRef(null);
    const dataGrid = useRef(null);

    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    const gridKey = "0907EBE8-6FDA-4C79-8F5E-53FC6A93B19A";
    const [currentLayout, setCurrentLayout] = useState("Default");
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken, null, currentLayout); }, [currentLayout]);
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);

    const initialFormFields = {
        chargeCode: '',
        description: '',
        description1: '',
        description2: '',
        chargeType: '',
        revenueGroup: '',
        frequency: '',
        storageTiming: '',
        rateTableQuantityBasis: '',
        progressiveRateBasis: '',
        progressiveRateIncreaseCycle: '',
        progressiveRateStartPeriod: '',
        billingFlag: '',
        status: '',
        managementSource: '',
        taxable: '',
        discountable: '',
        commissionable: '',
        chargeBasisLevel: '',
        rateSource: '',
        applyMinAmtOnFreeDays: '',
        chargeUom: '',
        maximumChargeAmount: '',
        dateAdjustmentDays: '',
        storageAvgDailyBal: '',
        storageBeginDate: '',
        storageLastMonth: '',
        storageFirstMonth: '',
        dateAdjustment: '',
        chargeBasisUnits: '',
        userDefinedCode1: '',
        userDefinedCode2: '',
        userDefinedCode3: '',
        userDefinedCode4: '',
        userDefinedCode5: '',
        userDefinedCode6: '',
        userDefinedCode7: '',
        userDefinedCode8: '',
        userDefinedCode9: '',
        userDefinedCode10: '',
        userDefinedDate1: '',
        userDefinedDate2: '',
        userDefinedDate3: '',
        userDefinedDate4: '',
        userDefinedDate5: '',
        userDefinedDate6: '',
        userDefinedDate7: '',
        userDefinedDate8: '',
        userDefinedDate9: '',
        userDefinedDate10: '',
        userDefinedReference1: '',
        userDefinedReference2: '',
        userDefinedReference3: '',
        userDefinedReference4: '',
        userDefinedReference5: '',
        userDefinedReference6: '',
        userDefinedReference7: '',
        userDefinedReference8: '',
        userDefinedReference9: '',
        userDefinedReference10: '',
        unitChargeRate: ''
    };
    const [formFields, setformFields] = useState(initialFormFields);
    const formFieldsRef = useRef(formFields);
    
    // Keep ref in sync with state
    useEffect(() => {
        formFieldsRef.current = formFields;
    }, [formFields]);

    const onSelectionChanged = ({ selectedRowsData }) => {
        if (selectedRowsData && selectedRowsData.length == 1) {
            rowId.current = selectedRowsData[0].RowId;
            setIsEditButtonDisabled(false);
        } else {
            rowId.current = '';
            setIsEditButtonDisabled(true);
        }
    };

    const handleEditClick = () => {
        const buttonUrl = "/wm/codes/edit-charge-code?id=" + rowId.current;
        history.push(buttonUrl);
    };

    const selectionChanged = useCallback(
        (e, tg) => {
            let newItems = [...selectedItems];
            e.removedItems.forEach((item) => {
                const index = newItems.indexOf(item);
                if (index >= 0) {
                    newItems.splice(index, 1);
                }
            });
            if (e.addedItems.length) {
                newItems = [...newItems, ...e.addedItems];
            }
            setSelectedItems(newItems);
            setSearchPanelStatus((prevStatus) => {
                const newStatus = !prevStatus;
                return newStatus;
            });
        },
        [selectedItems, setSelectedItems],
    );

    const handleSearch = (e) => {
        e.event.stopPropagation();
        // Reload datasource with current formFields to trigger server-side filtering
        let datasource = loadDatasource();
        setResultData(datasource);
        // Trigger reload to apply new filter
        if (dataGrid.current && dataGrid.current.instance) {
            dataGrid.current.instance.refresh();
        }
    };

    const handleReset = (e) => {
        e.event.stopPropagation();
        setformFields(initialFormFields);
        // Reload datasource with reset fields
        setTimeout(() => {
            setResultData(loadDatasource());
        }, 100);
    };

    useEffect(() => {
        // Initialize datasource on mount
        if (!resultData) {
            setResultData(loadDatasource());
        }
    }, []);

    const handleFormLoad = useCallback(() => {
        // Load charge types as hardcoded values
        const chargeTypes = [
            { id: 'I', text: 'Item Charge' },
            { id: 'T', text: 'Transaction Charge' },
            { id: 'S', text: 'Storage Charge' },
            { id: 'F', text: 'Freight Charge' },
            { id: 'H', text: 'Handling Charge' },
            { id: 'A', text: 'Accessorial Charge' },
            { id: 'O', text: 'Other Charge' }
        ];
        loadLookupFromStaticData(formRefs, "chargeType", chargeTypes);

        // Load frequency values as hardcoded values
        const frequencies = [
            { id: 'W', text: 'First Day of Week (Sunday)' },
            { id: 'B', text: 'First Day of BI-Week (Every 2nd Sunday)' },
            { id: 'M', text: 'First Day of Month (1st)' },
            { id: 'S', text: 'First Day of Semi Monthly (1st + 16th)' },
            { id: 'A', text: 'Anniversary Date' }
        ];
        loadLookupFromStaticData(formRefs, "frequency", frequencies);

        // Load storage timing options
        const storageTimingOptions = [
            { id: 'A', text: 'Ahead' },
            { id: 'B', text: 'Behind' }
        ];
        loadLookupFromStaticData(formRefs, "storageTiming", storageTimingOptions);

        // Load rate table quantity basis options
        const rateTableQuantityBasisOptions = [
            { id: 'C', text: 'Charge Bill As Quantity' },
            { id: 'Q', text: 'Unit Volume' },
            { id: 'U', text: 'Flat Rate' }
        ];
        loadLookupFromStaticData(formRefs, "rateTableQuantityBasis", rateTableQuantityBasisOptions);

        // Load progressive rate basis options (assuming similar to other flag fields)
        const progressiveRateBasisOptions = [
            { id: 'Y', text: 'Yes' },
            { id: 'N', text: 'No' }
        ];
        loadLookupFromStaticData(formRefs, "progressiveRateBasis", progressiveRateBasisOptions);

        // Load billing flag options
        const billingFlagOptions = [
            { id: 'Y', text: 'Yes' },
            { id: 'N', text: 'No' }
        ];
        loadLookupFromStaticData(formRefs, "billingFlag", billingFlagOptions);

        // Load status options
        const statusOptions = [
            { id: 'A', text: 'Active' },
            { id: 'I', text: 'Inactive' }
        ];
        loadLookupFromStaticData(formRefs, "status", statusOptions);

        // Load management source options
        const managementSourceOptions = [
            { id: 'I', text: 'Item' },
            { id: 'L', text: 'Lot' }
        ];
        loadLookupFromStaticData(formRefs, "managementSource", managementSourceOptions);

        // Load taxable options
        const taxableOptions = [
            { id: 'N', text: 'No' },
            { id: 'Y', text: 'Yes, Apply Tax 1 Only' },
            { id: 'A', text: 'Yes, Apply Tax 2 Only' },
            { id: 'B', text: 'Yes, Apply Both Tax 1 & Tax 2' }
        ];
        loadLookupFromStaticData(formRefs, "taxable", taxableOptions);

        // Load discountable options
        const discountableOptions = [
            { id: 'Y', text: 'Yes' },
            { id: 'N', text: 'No' }
        ];
        loadLookupFromStaticData(formRefs, "discountable", discountableOptions);

        // Load commissionable options
        const commissionableOptions = [
            { id: 'Y', text: 'Yes' },
            { id: 'N', text: 'No' }
        ];
        loadLookupFromStaticData(formRefs, "commissionable", commissionableOptions);

        // Load charge basis level options
        const chargeBasisLevelOptions = [
            { id: 'I', text: 'Item' },
            { id: 'L', text: 'Lot' },
            { id: 'S', text: 'Sub Lot' },
            { id: 'U', text: 'Unit' }
        ];
        loadLookupFromStaticData(formRefs, "chargeBasisLevel", chargeBasisLevelOptions);

        // Load rate source options
        const rateSourceOptions = [
            { id: 'S', text: 'Single Rate' },
            { id: 'T', text: 'Rate Table' }
        ];
        loadLookupFromStaticData(formRefs, "rateSource", rateSourceOptions);

        // Load apply min amt on free days options
        const applyMinAmtOnFreeDaysOptions = [
            { id: 'Y', text: 'Yes' },
            { id: 'N', text: 'No' }
        ];
        loadLookupFromStaticData(formRefs, "applyMinAmtOnFreeDays", applyMinAmtOnFreeDaysOptions);

        // Load charge basis units options
        const chargeBasisUnitsOptions = [
            { id: 'A', text: 'Area1' },
            { id: 'E', text: 'Manually Enter The Quantity' },
            { id: 'F', text: 'Flat' },
            { id: 'G', text: 'Gross weight' },
            { id: 'H', text: 'Shipment (eg. Container)' },
            { id: 'I', text: 'Inventory Unit' },
            { id: 'K', text: 'Packages (eg. Pallets)' },
            { id: 'L', text: '# Line items' },
            { id: 'N', text: 'Net Weight' },
            { id: 'P', text: 'Pieces' },
            { id: 'S', text: '# Sublots' },
            { id: 'T', text: 'Amount' },
            { id: 'U', text: 'Value' },
            { id: 'V', text: 'Volume' }
        ];
        loadLookupFromStaticData(formRefs, "chargeBasisUnits", chargeBasisUnitsOptions);

        // Load storage avg daily bal options (assuming Y/N)
        const storageAvgDailyBalOptions = [
            { id: 'Y', text: 'Yes' },
            { id: 'N', text: 'No' }
        ];
        loadLookupFromStaticData(formRefs, "storageAvgDailyBal", storageAvgDailyBalOptions);

        // Load storage begin date options (assuming Y/N)
        const storageBeginDateOptions = [
            { id: 'Y', text: 'Yes' },
            { id: 'N', text: 'No' }
        ];
        loadLookupFromStaticData(formRefs, "storageBeginDate", storageBeginDateOptions);

        // Load storage last month options (assuming Y/N)
        const storageLastMonthOptions = [
            { id: 'Y', text: 'Yes' },
            { id: 'N', text: 'No' }
        ];
        loadLookupFromStaticData(formRefs, "storageLastMonth", storageLastMonthOptions);

        // Load storage first month options (assuming Y/N)
        const storageFirstMonthOptions = [
            { id: 'Y', text: 'Yes' },
            { id: 'N', text: 'No' }
        ];
        loadLookupFromStaticData(formRefs, "storageFirstMonth", storageFirstMonthOptions);

        // Load date adjustment options (assuming Y/N)
        const dateAdjustmentOptions = [
            { id: 'Y', text: 'Yes' },
            { id: 'N', text: 'No' }
        ];
        loadLookupFromStaticData(formRefs, "dateAdjustment", dateAdjustmentOptions);
    }, []);

    const loadLookupFromStaticData = (formRefs, name, dataSource) => {
        if (formRefs.current[name]) {
            formRefs.current[name].instance().option('dataSource', dataSource);
            formRefs.current[name].instance().option('valueExpr', 'id');
            formRefs.current[name].instance().option('displayExpr', 'text');
            if (formFields[name])
                formRefs.current[name].instance().option('value', formFields[name]);
        }
    };

    const handleFieldChange = useCallback((name, value) => {
        // Handle field changes if needed
    }, []);

    const loadDatasource = () => {
        // Map formFields to ChargeCodesFilter structure
        const mapToChargeCodeFilter = (fields) => {
            return {
                ChargeCode: fields.chargeCode || '',
                Description: fields.description || '',
                ChargeType: fields.chargeType || '',
                RevenueGroup: fields.revenueGroup || '',
                Frequency: fields.frequency || '',
                Status: fields.status || '',
                RowId: null
            };
        };

        let store = createStore({
            key: 'RowId',
            loadParams: {
                'chargeCodeFilter.ChargeCode': function() {
                    const filter = mapToChargeCodeFilter(formFieldsRef.current);
                    return filter.ChargeCode;
                },
                'chargeCodeFilter.Description': function() {
                    const filter = mapToChargeCodeFilter(formFieldsRef.current);
                    return filter.Description;
                },
                'chargeCodeFilter.ChargeType': function() {
                    const filter = mapToChargeCodeFilter(formFieldsRef.current);
                    return filter.ChargeType;
                },
                'chargeCodeFilter.RevenueGroup': function() {
                    const filter = mapToChargeCodeFilter(formFieldsRef.current);
                    return filter.RevenueGroup;
                },
                'chargeCodeFilter.Frequency': function() {
                    const filter = mapToChargeCodeFilter(formFieldsRef.current);
                    return filter.Frequency;
                },
                'chargeCodeFilter.Status': function() {
                    const filter = mapToChargeCodeFilter(formFieldsRef.current);
                    return filter.Status;
                },
                'chargeCodeFilter.RowId': function() {
                    const filter = mapToChargeCodeFilter(formFieldsRef.current);
                    return filter.RowId;
                }
            },
            loadUrl: `${window._env_.REACT_APP_APIS}/${data.ChargeCode.GetChargeCodes}`,
            onBeforeSend: (method, ajaxOptions) => {
                ajaxOptions.headers = {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                };
            },
        });
        const dataSource = new DataSource({ store: store });
        return dataSource;
    };

    const [resultData, setResultData] = useState(null);

    return (
        <div className="search-page-container">
            <div className="search-page-content">
                <div id="accordion" className="search-page-accordion">
                    <AccordionReact
                        dataSource={searchpanel}
                        collapsible={true}
                        multiple={false}
                        animationDuration={300}
                        selectedItems={selectedItems}
                        onSelectionChanged={e => {
                            if (e.currentTarget === e.target) {
                                selectionChanged(e, e.target);
                            }
                        }}
                        itemTitleRender={() => (
                            <Toolbar className="accordian-toolbar">
                                <Item location="before">
                                    <div className="title">
                                        <h6
                                            style={{
                                                color: window._env_.Color2
                                            }}
                                        >
                                            Enter Your Query For Charge Code
                                        </h6>
                                    </div>
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={handleSearch} text="Search" type="default" />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={handleReset} text="Reset" />
                                </Item>
                            </Toolbar>
                        )}
                        itemRender={(itemProps) => (
                            <FormField
                                currrentUser={currentUser}
                                layoutId='2C7D7C0B-DF1A-435C-88B7-AE576DBC4A55'
                                layoutName='WMChargeCodeSearchForm'
                                defaultFormSchema={SearchLayout}
                                formFields={formFields}
                                setformFields={setformFields}
                                handleFieldValueChange={handleFieldChange}
                                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                                formRefs={formRefs}
                                onFormLoad={handleFormLoad}
                                noSpacingBeforeFirstRow={true}
                            />
                        )}
                        id="accordion-container" className="accordion-height"
                    />
                </div>
                <div className="search-page-grid-container">
                    <DataGrid
                        onExporting={(e) => {
                            if (window.handleDevExtremeDataGridExport) {
                                window.handleDevExtremeDataGridExport(e);
                            }
                        }}
                        ref={dataGrid}
                        allowColumnReordering={true}
                        allowColumnResizing={true}
                        dataSource={resultData}
                        showBorders={true}
                        hoverStateEnabled={true}
                        className="search-page-grid"
                        onSelectionChanged={(e) => onSelectionChanged(e)}
                        remoteOperations={true}
                        searchEnabled={true}
                        columnAutoWidth={true}
                    >
                        <ColumnChooser
                            enabled={true}
                            title="Choose Column"
                            width={290}
                            height={290}
                            sortOrder="asc"
                        >
                            <ColumnChooserSearch
                                enabled={true}
                                editorOptions={{ placeholder: 'Search column' }} />
                        </ColumnChooser>
                        <Export enabled={true} allowExportSelectedData={true} />
                        <Selection mode="multiple" />
                        <Sorting visible={true} mode="multiple" />
                        <Paging defaultPageSize={10} />
                        <Pager
                            visible={true}
                            showPageSizeSelector={true}
                            allowedPageSizes={allowedPageSizes}
                            showNavigationButtons={true}
                        />
                        <FilterRow visible={true} />
                        <FilterPanel visible={true} />
                        <GroupPanel visible={true} />
                        <Grouping autoExpandAll={false} />
                        <StateStoring
                            enabled={true}
                            type="custom"
                            customLoad={loadState}
                            storageKey={gridKey}
                            customSave={saveState}
                        />
                        <GridToolbar>
                            <GridToolbarItem location="before">
                                <Button
                                    disabled={isEditButtonDisabled}
                                    onClick={handleEditClick}
                                    type="default"
                                    text="Edit"
                                ></Button>
                            </GridToolbarItem>
                            <GridToolbarItem location="before">
                                <div>
                                    <Link to="/wm/codes/add-charge-code">
                                        <Button
                                            type="default"
                                            className="gridTopButton"
                                            text="Create"
                                        ></Button>
                                    </Link>
                                </div>
                            </GridToolbarItem>
                            <GridToolbarItem name="columnChooserButton" />
                            <GridToolbarItem name="exportButton" />
                            <GridToolbarItem location="after">
                                <GridLayoutManager
                                    gridKey={gridKey}
                                    gridRef={dataGrid}
                                    currentLayout={currentLayout}
                                    setCurrentLayout={setCurrentLayout}
                                    accessToken={accessToken}
                                />
                            </GridToolbarItem>
                        </GridToolbar>
                        <Column dataType="string" caption="Charge Code" dataField="ChargeCode" />
                        <Column dataType="string" caption="Description-1" dataField="Description1"  />
                        <Column dataType="string" caption="Type" dataField="ChargeType"  />
                        <Column dataType="string" caption="Timing" dataField="StorageTiming"  />
                        <Column dataType="string" caption="Qty Basis" dataField="RateTableQuantityBasis"  />
                        <Column dataType="string" caption="Progressive" dataField="ProgressiveRateBasis"   />
                        <Column dataType="number" caption="Prog. Cycle Inc" dataField="ProgressiveRateIncreaseCycle"  />
                        <Column dataType="number" caption="Prog. Factor" dataField="ProgressiveRateStartPeriod"   />
                        <Column dataType="string" caption="Billing" dataField="BillingFlag"  />
                        <Column dataType="string" caption="Frequency" dataField="StorageFrequency" visible={false} />

                        <Column dataType="string" caption="Mgmt Unit" dataField="ManagementSource" visible={false} />
                        <Column dataType="string" caption="Taxable" dataField="Taxable" visible={false} />
                        <Column dataType="string" caption="Discountable" dataField="Discountable" visible={false} />
                        <Column dataType="string" caption="Commission" dataField="Commissionable" visible={false} />
                        <Column dataType="string" caption="Level" dataField="ChargeBasisLevel" visible={false} />
                        <Column dataType="string" caption="Rate Source" dataField="RateSource" visible={false} />
                        <Column dataType="string" caption="Status" dataField="Status" visible={false} />
                        <Column dataType="string" caption="Apply Min Amt" dataField="ApplyMinAmtOnFreeDays" visible={false} />



                        <Column dataType="string" caption="Description 2" dataField="Description2" visible={false} />
                        <Column dataType="string" caption="Charge UOM" dataField="ChargeUom" visible={false} />
                        <Column dataType="number" caption="Maximum Amt" dataField="MaximumChargeAmount" format="#,##0.00" visible={false} />
                        <Column dataType="number" caption="Minimum Amt" dataField="MinimumChargeAmount" format="#,##0.00" visible={false} />
                        <Column dataType="number" caption="# Of Days" dataField="DateAdjustmentDays" visible={false} />
                        <Column dataType="string" caption="Avg Daily Bal" dataField="StorageAvgDailyBal" visible={false} />
                        <Column dataType="string" caption="Start Period" dataField="StorageBeginDate" visible={false} />
                        <Column dataType="string" caption="Last Month" dataField="StorageLastMonth" visible={false} />
                        <Column dataType="string" caption="First Month" dataField="StorageFirstMonth" visible={false} />
                        {/* <Column dataType="string" caption="Date Adjustment" dataField="DateAdjustment" visible={false} /> */}
                        <Column dataType="string" caption="Minimum Units" dataField="ChargeBasisUnits" visible={false} />
                        <Column dataType="string" caption="Code 1" dataField="UserDefinedCode1" visible={false} />
                        <Column dataType="string" caption="Code 2" dataField="UserDefinedCode2" visible={false} />
                        <Column dataType="string" caption="Code 3" dataField="UserDefinedCode3" visible={false} />
                        <Column dataType="string" caption="Code 4" dataField="UserDefinedCode4" visible={false} />
                        <Column dataType="string" caption="Code 5" dataField="UserDefinedCode5" visible={false} />
                        <Column dataType="string" caption="Code 6" dataField="UserDefinedCode6" visible={false} />
                        <Column dataType="string" caption="Code 7" dataField="UserDefinedCode7" visible={false} />
                        <Column dataType="string" caption="Code 8" dataField="UserDefinedCode8" visible={false} />
                        <Column dataType="string" caption="Code 9" dataField="UserDefinedCode9" visible={false} />
                        <Column dataType="string" caption="Code 10" dataField="UserDefinedCode10" visible={false} />
                        <Column dataType="date" caption="Date 1" dataField="UserDefinedDate1" format="MM/dd/yyyy" visible={false} />
                        <Column dataType="date" caption="Date 2" dataField="UserDefinedDate2" format="MM/dd/yyyy" visible={false} />
                        <Column dataType="date" caption="Date 3" dataField="UserDefinedDate3" format="MM/dd/yyyy" visible={false} />
                        <Column dataType="date" caption="Date 4" dataField="UserDefinedDate4" format="MM/dd/yyyy" visible={false} />
                        <Column dataType="date" caption="Date 5" dataField="UserDefinedDate5" format="MM/dd/yyyy" visible={false} />
                        <Column dataType="date" caption="Date 6" dataField="UserDefinedDate6" format="MM/dd/yyyy" visible={false} />
                        <Column dataType="date" caption="Date 7" dataField="UserDefinedDate7" format="MM/dd/yyyy" visible={false} />
                        <Column dataType="date" caption="Date 8" dataField="UserDefinedDate8" format="MM/dd/yyyy" visible={false} />
                        <Column dataType="date" caption="Date 9" dataField="UserDefinedDate9" format="MM/dd/yyyy" visible={false} />
                        <Column dataType="date" caption="Date 10" dataField="UserDefinedDate10" format="MM/dd/yyyy" visible={false} />
                        <Column dataType="string" caption="Reference 1" dataField="UserDefinedReference1" visible={false} />
                        <Column dataType="string" caption="Reference 2" dataField="UserDefinedReference2" visible={false} />
                        <Column dataType="string" caption="Reference 3" dataField="UserDefinedReference3" visible={false} />
                        <Column dataType="string" caption="Reference 4" dataField="UserDefinedReference4" visible={false} />
                        <Column dataType="string" caption="Reference 5" dataField="UserDefinedReference5" visible={false} />
                        <Column dataType="string" caption="Reference 6" dataField="UserDefinedReference6" visible={false} />
                        <Column dataType="string" caption="Reference 7" dataField="UserDefinedReference7" visible={false} />
                        <Column dataType="string" caption="Reference 8" dataField="UserDefinedReference8" visible={false} />
                        <Column dataType="string" caption="Reference 9" dataField="UserDefinedReference9" visible={false} />
                        <Column dataType="string" caption="Reference 10" dataField="UserDefinedReference10" visible={false} />
                        <Column dataType="string" caption="Revenue Grp" dataField="RevenueGroup" visible={false} />
                        <Column dataType="number" caption="Charge Rate" dataField="UnitChargeRate" format="#,##0.00" visible={false} />
                        
                       
                    </DataGrid>
                </div>
            </div>
        </div>
    );
};

function mapStateToProps(state) {
    return {
        oidc: state.oidc
    };
}

export default connect(mapStateToProps)(List);
